// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__WkpLD g-grid-container","inner":"style_inner__slCho g-grid","text":"style_text__g8Pxy","mobileCtas":"style_mobileCtas__uI_tf","ctas":"style_ctas__ilDMu"};